import { getAssetsUrl } from "../../../shared/pipes/assets-url/assets-url"

export interface IResult {
    success: boolean
    status: string
    message: string
    data?: IEjecucionPalanca[]
}

export interface IResultSaveInsue {
    success: boolean
    status: string
    message: string
    data: { Success: string }
}

export interface IResulApi {
    success: boolean
    status: string
    message: string
    data: IEjecucionPalanca | IEjecucionPalanca[]
}

interface ITareaActiva {
    ID_Ejecucion_Tarea_Detalle: number
    ID_Ejecucion_Tendero?: number;
    FechaEjecucion?: string
    Duracion?: number
    TiempoRestante?: string
    HorarioEjecucion?: string
    FechaEjecucionFin?: string
    General_Cuantas_Fotos?: number
    NeedTake?: string
    Necessary?: string
    isPhotography?: boolean
}

interface ITareaEnviada {
    Send?: string
    Alta?: string
    Fotos_Tomadas?: string
}

interface ISendApi {
    Foto_Url?: string
    ID_Ejecucion_Evidencia_Tendero?: number
    isSend?: boolean
}

export interface IEjecucionPalanca extends ITareaActiva, ITareaEnviada, ISendApi {
    Code: number
    ID_Ejecucion_Palanca_Comercial: number
    PalancaComercial?: string
    Imagen?: string
    Imagen_Enfriador?: string
    Descripcion?: string
    Consejo?: string
    Instruccion?: string
    ID_Tendero?: number
    ConfigEjecucion?: IConfigEjecucion
    ConfigCamera?: IConfigCamera
    Toast?: IToast
    Check: boolean
    image_base_64?: string[]
    Consulta_Resultados?: boolean;
    Nuevo_Resultado?: boolean;
    EjecucionIncidencia?: IEjecucionIncidencia[];
    message?: string;
}

export interface IUploadPictures {
    Code: number;
    ID_Ejecucion_Tarea_Detalle: number;
    ID_Ejecucion_Palanca_Comercial: number;
    ID_Ejecucion_Tendero: number;
    ID_Tendero: number;
    files: Blob[];
    Check: boolean;
    Send: string | null;
    Alta: string | null;
    Fotos_Tomadas: string | null;
}

export interface IEjecucionIncidencia {
    ID_EjecucionIncidencias?: number
    Activo: boolean
    Titulo?: string
    CaracterMinimo?: number
    CaracterMaximo?: number
    Boton?: string
    ID_Bodega?: number
    NUD?: number
    ErrorSend?: string
}

export interface ITakePicture {
    height?: number
    width?: number
    quality?: number
}

export interface IConfigEjecucion {
    header?: Header
    content?: Content
    resolution?: Resolution
    buttons?: Buttons
}

export interface Header {
    icono?: string
    texto?: string
    timerText?: string
}

export interface Content {
    iconoTitle: string
    iconoConsejo: string
    iconoImageSend: string
    iconoImageNotSend: string
}

export interface Resolution {
    height: number
    width: number
}

export interface Buttons {
    buttomPhotography: string
    buttomSend: string
}

export interface IConfigCamera {
    header?: Header1
    buttons?: Buttons1
    takePicture?: ITakePicture
    modalConfirm?: IModalConfirm
    modalClear?: IModalConfirm
}

export interface Header1 {
    title: string
    iconoConsejo: string
}

export interface Buttons1 {
    cameraIcon: string
    buttomSend: string
    buttomClear: string
}

export interface IModalConfirm {
    text: string
    subText?: string
    buttomLeft: ButtomsModal
    buttomRight: ButtomsModal
    backdropDismiss: boolean
}

interface ButtomsModal {
    class: string
    text: string
}

export interface IToast {
    success: string
    error: string
    icon?: string
    timeout?: string
    repeated?: string
}

export interface IGratitude {
    fontImage?: string
    icon?: string
    gratitude?: string
    texto?: string
    bottom?: string
}

export const CAMERA_PREVIEW = {
    header: {
        title: 'Foto de ',
        // tslint:disable-next-line: max-line-length
        iconoConsejo: getAssetsUrl('iconos%2Flightbulb.svg')
    },
    buttons: {
        // tslint:disable-next-line: max-line-length
        cameraIcon: getAssetsUrl('iconos%2Fcamera-big.svg'),
        buttomSend: 'ENVIAR',
        buttomClear: 'LIMPIAR'
    },
    takePicture: {
        height: 1280,
        width: 720,
        quality: 100
    },
    modalConfirm: {
        text: '¿Seguro qué deseas salir?',
        subText: 'Todas las fotos que hayas tomado en esta sección se borrarán',
        buttomLeft: {
            class: 'ion-text-uppercase',
            text: 'Aceptar'
        },
        buttomRight: {
            class: 'ion-text-uppercase',
            text: 'Cancelar'
        },
        backdropDismiss: true
    },
    modalClear: {
        text: '¿Seguro qué deseas limpiar?',
        subText: 'Todas las fotos que hayas tomado en esta sección se borrarán',
        buttomLeft: {
            class: 'ion-text-uppercase',
            text: 'Aceptar'
        },
        buttomRight: {
            class: 'ion-text-uppercase',
            text: 'Cancelar'
        },
        backdropDismiss: true
    }
}

export const TOAST_EJECUCION = {
    icon: 'simple-slickpic',
    success: 'Has enviado tus fotos de éxito de {{ tipo }}. Sigue así y gana más con GEPP.',
    error: 'Ocurrio un error al enviar las fotos, intentalo más tarde',
    timeout: 'Lo sentimos el tiempo de la tarea concluyo.',
    repeated: 'Lo sentimos, no es posible enviar nuevamente tus fotos de éxito.'
}

export interface IResultEjecucion {
    success: boolean;
    message: string;
    data: IResultProceso[];
}

export interface IResultProceso {
    fechaProceso: string;
    resultados: IResultDeatail[];
}

export interface IResultDeatail {
    idBodega: number;
    nud: number;
    fechaEvaluacion: string;
    fechaProceso: string;
    idPalancaComercial: number;
    nombrePalancaComercial: string;
    detallesPalanca: IDetallesPalanca;
    criteriosEvaluacion: ICriterioEvaluacion[];
    fotos: string[];
    cumple: number;
}

export interface IDetallesPalanca {
    tipoRack?: string;
    niveles?: number;
    numeroPuertas?: number;
    marca?: string;
}

export interface ICriterioEvaluacion {
    idTipoEvaluacion: number;
    activo: boolean;
    cumple: boolean;
    objetivo: number;
    real: number;
    detalle: string;
    tituloEvaluacion: string;
    imagen: string;
    descripcion: string;
}
